import React from "react";
import { makeStyles } from '@mui/styles';
import Modal from "@mui/material/Modal";
import Backdrop from "@mui/material/Backdrop";
import Fade from "@mui/material/Fade";

const useStyles = makeStyles(theme => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    '& .MuiBackdrop-root': {
      backgroundColor: 'rgba(0, 0, 0, 0.5)'
    }
  },
  paper: {
    backgroundColor: "#ffffff",
    padding: theme.spacing(2, 4, 3),
    borderRadius: "15px",
    width: "380px",
    position: 'relative',
    outline: 'none',
    boxShadow: '0px 3px 5px -1px rgba(0,0,0,0.2), 0px 5px 8px 0px rgba(0,0,0,0.14), 0px 1px 14px 0px rgba(0,0,0,0.12)'
  }
}));

export default function TransitionsModal({ onConfirm, open, examDetail, photoMismatchCount }) {

  const classes = useStyles();


  return (
    <div>
      <Modal
        open={open}
        disableEnforceFocus={true}
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={open}>
          <div className={classes.paper} style={{ textAlign: "justify" }}>
            {(examDetail[0].imageproctoringcount - photoMismatchCount) < 0
              ?
              <h3 id="transition-modal-title" style={{ color: '#6f2981', marginBottom: "30px", textAlign: 'center' }}>
                Violation of Rule !!!
              </h3>
              :
              (examDetail[0].imageproctoringcount - photoMismatchCount) === 0
                ?
                <h3 id="transition-modal-title" style={{ color: '#6f2981', marginBottom: "30px", textAlign: 'center' }}>
                  Last Warning!!
                </h3>
                :
                <h3 id="transition-modal-title" style={{ color: '#6f2981', marginBottom: "30px", textAlign: 'center' }}>
                  Warning!!
                </h3>
            }
            {(examDetail[0].imageproctoringcount - photoMismatchCount) < 0
              ?
              <p id="transition-modal-description">
                You have violated the test requirement. You cannot continue the test. Your test results are being processed.
              </p>
              :
              (examDetail[0].imageproctoringcount - photoMismatchCount) === 0
                ?
                <p id="transition-modal-description">
                  This is the final warning where your face is not getting detected by AI. Once you click on OK, AI will try to match the face again. If the match is not found, your test results will get submitted automatically.
                </p>
                :
                <p id="transition-modal-description">
                  Your face is not detected by AI or it doesn’t match with the first Image. Once you click on OK, AI will try to match the face again. Please ensure that your face is detected properly, else you will not be allowed to attempt this test.
                </p>
            }
            {(examDetail[0].imageproctoringcount - photoMismatchCount) >= 0 &&
              <div style={{ display: 'flex', justifyContent: 'space-around' }}>
                <button className="btn btn-blue" style={{ borderRadius: "10px" }} onClick={onConfirm}>
                  Ok
                </button>
              </div>}
            {(examDetail[0].imageproctoringcount - photoMismatchCount) < 0 &&
              <div style={{ display: 'flex', justifyContent: 'space-around' }}>
                <button className="btn btn-blue" style={{ borderRadius: "10px" }} onClick={onConfirm}>
                  Close
                </button>
              </div>}





          </div>
        </Fade>
        {/* <Fade in={open}>
          {Count === 2 && <div className={classes.paper} style={{ textAlign: "justify" }}>
            <h3 id="transition-modal-title" style={{ color: '#6f2981', marginBottom: "30px" }}>
              Warning!!
            </h3>
            
            <div style={{ display: 'flex', justifyContent: 'space-around' }}>
              <button className="btn btn-blue" style={{ borderRadius: "10px" }} onClick={onConfirm}>
                Ok
              </button>
            </div>
          </div>}
          </Fade>
          <Fade in={open}>
          {Count === 3 && <div className={classes.paper} style={{ textAlign: "justify" }}>
            <h3 id="transition-modal-title" style={{ color: '#6f2981', marginBottom: "30px" }}>
              Warning!!!
            </h3>
            
            <div style={{ display: 'flex', justifyContent: 'space-around' }}>
              <button className="btn btn-blue" style={{ borderRadius: "10px" }} onClick={onConfirm}>
                Ok
              </button>
            </div>
          </div>}
          </Fade>
          <Fade in={open}>
          {Count === 4 && <div className={classes.paper} style={{ textAlign: "justify" }}>
            <h3 id="transition-modal-title" style={{ color: '#6f2981', marginBottom: "30px" }}>
              We are submitting your test 
            </h3>
            
          </div>}
           */}
        {/* </Fade> */}
      </Modal>
    </div>
  );
}
